import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FilterDropdown from '../../Shared/FilterDropdown/FilterDropdown';
import * as AppState from '../../../AppState';

import './savedHomeSearch.scss';
import { useRecoilValue } from 'recoil';
import React, { useState, useReducer, useEffect } from 'react';
import { SavedHomeSearchDropdownComponent } from './SavedHomeSearchDropdown';
import { getOrInitUserId } from '../../../services/Firebase';
import { frequency } from './FrequencySelectInput';
import { getAuthToken } from '../../../services/AuthHelper';

const initialSearchState = {
	name: '',
	email: '',
	zip: '',
	marketingOptIn: true,
  frequency: {label: frequency.Daily, value: 3}
};

const searchReducer = (state: any, action: any) => {
	switch (action.type) {
		case 'setName':
			return { ...state, name: action.value };
		case 'setEmail':
			return { ...state, email: action.value };
    case 'setOptIn':
      if(action.value === false){
        return { ...state, frequency:{label: frequency.Never, value: 0}, marketingOptIn: action.value };
      }
      return { ...state, frequency:{label: frequency.Daily, value: 3},  marketingOptIn: action.value };
    case 'setFrequency':
      return { ...state, frequency: action.value };
		case 'clearInformation':
			return initialSearchState;
		default:
			return state;
	}
};

const SavedHomeSearchButton = () => {

	const [search, dispatch] = useReducer(searchReducer, initialSearchState);

	const [loading, setLoading] = useState(false);

  const [token, setToken] = useState<string>();

	const gsScreenWidth = useRecoilValue(AppState.gsScreenWidth);

  useEffect(()=>{
    setToken(getAuthToken())
  },[])

  if(!token ){
    return <></>
  }

	return <FilterDropdown
		active={false}
		disableActive
		outline={false}
		onResetClick={() => void 0}
		label={loading ?
			<div>
				<FontAwesomeIcon icon={['far', 'spinner']} className='m-0 mx-4 px-3 cc-btn__icon cc-btn__icon--prefix spinner' />
			</div>
			:
			<div>

				{gsScreenWidth > 1200 ? 'Save your search' : <FontAwesomeIcon icon={['far', 'envelope']} className='m-0 mx-2 p-0 cc-btn__icon cc-btn__icon--prefix' />}
			</div>
		}
		id={'saved-home-search-dropdown'}
		wrapperClass='saved-home-search--dropdown-wrapper'
		className={'cc-shadow--light cc-btn--filled cc-btn--primary cc-btn--reset-text cc-btn--navbar cc-color--white-100 h-100 d-flex saved-home-search--dropdown-button'}
		options={
			<SavedHomeSearchDropdownComponent
				search={search}
				dispatch={dispatch}
				setLoading={setLoading}
			/>
		}
		disableBottomButtons
	/>;
};

export default SavedHomeSearchButton;
